import { hdcAutoPayAlertMock } from "../builders/createInsuranceBill";
import { getHdc1Dot0Membership } from "../builders/getHdc1Dot0Membership";
import { legacyUsSecondGearMember } from "../mockMembers";
import { mockPolicies } from "../mockPolicies";
import { cigHdcAutoPayFailedBill } from "../builders/createCigBill";

import { MockPersona } from "./mockPersonas.types";

export const janeDoe: MockPersona = {
  key: "janeDoe",
  name: "Jane Doe",
  description: "🇺🇸 | One core policy | HDC 1.0 Single-tier | HDC Autopay failed",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [cigHdcAutoPayFailedBill("1.0", {})],
      },
      policies: {
        usa: [mockPolicies["PL674825-01"]],
        canada: [],
      },
    },
    hdc: {
      fetch1Dot0Membership: getHdc1Dot0Membership({ ProductCode: "USMEMB2" }),
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "jane@doe.com",
            firstName: "Jane",
            middleName: "Marie",
            lastName: "Doe",
            mailingAddress: {
              line1: "100 S. Main St",
              line2: "Apt 2B",
              city: "Motor City",
              state: "MI",
              postalCode: "40001-1234",
              country: "USA",
            },
            preferredPhone: "2025551212",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000012",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: legacyUsSecondGearMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [hdcAutoPayAlertMock()],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: undefined,
    },
  },
};
